import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import Moment from 'react-moment';
import { Link, navigate } from 'raviger';
import { Button, Card, Col, ListGroup, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faUserMd,
  faCheckSquare,
  faTimes,
  faArrowAltCircleLeft,
  faPrescription,
} from '@fortawesome/free-solid-svg-icons';
import {
  faEyeDropper,
  faPrescriptionBottlePill,
  faSquareExclamation,
  faSquareEllipsis,
  faFolderMedical,
  faSquareX,
  faSyringe,
  faHeart,
  faCancel
} from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment';
import Header from '../components/Header';
import LoadingLink from '../components/LoadingLink';
import ActionsDropdown from '../components/ActionsDropdown';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';

function TreatmentPlanDetails({ id, incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [data, setData] = useState({id: '', medical_record: null, animal_object:{name:'', id:''}, days:'', frequency: '', quantity: '', unit: '', route: '', treatment_requests:[]});
  const [isLoading, setIsLoading] = useState(true);
  const [trDict, setTRDict] = useState({});

  const [showModal, setShowModal] = useState(false);
  const cancelTreatmentPlan = () => {
    axios.delete('/vet/api/treatmentplan/' + id + '/?organization=' + organization)
    .catch(error => {
      setShowSystemError(true);
    });
    navigate("/" + organization + "/" + incident + "/vet/medrecord/" + data.medical_record + '?tab=treatments')
  }

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchTreatmentPlanData = async () => {
      // Fetch TreatmentPlan data.
      await axios.get('/vet/api/treatmentplan/' + id + '/', {
          cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let tr_dict = {}
          response.data.treatment_requests.forEach(tr => {
            // Get today's date
            var todaysDate = new Date();

            // tomorrow
            var tomorrowsDate = moment().add(1, 'day').format('DD MMM YYYY');
            // Date equals today's date
            if (new Date(tr.suggested_admin_time).setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
              tr_dict['Today'] = [...tr_dict['Today'] ? tr_dict['Today'] : [], tr];
            }
            // Date equals tomorrow's date
            else if (moment(tr.suggested_admin_time).format('DD MMM YYYY') == tomorrowsDate) {
              tr_dict['Tomorrow'] = [...tr_dict['Tomorrow'] ? tr_dict['Tomorrow'] : [], tr];
            }
            else {
              tr_dict[moment(tr.suggested_admin_time).format('MMMM Do')] = [...tr_dict[moment(tr.suggested_admin_time).format('MMMM Do')] ? tr_dict[moment(tr.suggested_admin_time).format('MMMM Do')] : [], tr];
            }
          })
          setTRDict(tr_dict);
          setData(response.data);
          setIsLoading(false)
        }
      })
      .catch(error => {
        setShowSystemError(true);
      });
    };
    fetchTreatmentPlanData();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id, incident]);

  return (
    <>
    <Header>
      <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + "/" + incident + "/vet/medrecord/" + data.medical_record + '?tab=treatments')} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
      Treatment Details
    </Header>
    <div className="row">
      <div className="col-6 d-flex">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between">
              <h4 className="h5 pt-2" style={{marginBottom:"10px"}}>
                <Row className="ms-0 pe-0">Information</Row>
              </h4>
              <ActionsDropdown variant="secondary" title="Actions">
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/treatment/edit/" + id}
                  isLoading={isLoading}
                  className="d-block"
                  label="Update All Unadministered Treatment Requests"
                >
                  <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                </LoadingLink>
                <LoadingLink
                  isLoading={isLoading}
                  className="d-block"
                  onClick={() => {setShowModal(true)}}
                  label="Cancel All Unadministered Treatment Requests"
                >
                  <FontAwesomeIcon icon={faCancel} className="fas" inverse />
                </LoadingLink>
              </ActionsDropdown>
            </div>
            <p className="phr pt-0 mt-1" />
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <b>Treatment: </b>{data.description}
                    {data.treatment_requests.length && data.treatment_requests[0].treatment_object.controlled ?
                    <OverlayTrigger
                      key={"treatment-controlled"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-treatment-controlled`}>
                          This treatment is a controlled substance.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faPrescription} className="ms-1" inverse />
                    </OverlayTrigger> : ""}
                    {/* <b>Status:</b> {data.treatment_requests.filter(tr => ['Pending', 'Scheduled'].includes(tr.status)).length > 0 ? 'Open' : 'Completed'} */}
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-4"><b>Quantity:</b> {data.quantity}</span>
                  <span className="col-4"><b>Unit:</b> {data.unit || '-'}</span>
                  <span className="col-4"><b>Route:</b> {data.route || '-'}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Frequency:</b> {data.days ? <span>every {data.frequency} hours</span> : "once"}</span>
                  {data.days ? <span className="col-6"><b>Duration:</b> for {data.days} days</span> : ""}
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
      <div className="col-6 d-flex ps-0">
        <Card className="border rounded" style={{width:"100%"}}>
          <Card.Body>
            <Card.Title>
              <h4 className="h5 pb-0" style={{marginBottom:"-3px"}}>Patient: {data.animal_object.name||"Unknown Name"}
              <span className="float-end">
                <OverlayTrigger
                  key={"medical-record"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-medical-record`}>
                      View patient medical record.
                    </Tooltip>
                  }
                >
                  <Link href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.medical_record} style={{textDecoration:"none", color:"white"}}><FontAwesomeIcon icon={faFolderMedical} className="" inverse /></Link>
                </OverlayTrigger></span>
              </h4>
            </Card.Title>
            <p className="phr"/>
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <div className="row" style={{textTransform:"capitalize"}}>
                  <span className="col-4"><b>ID:</b> <Link href={"/" + organization + "/" + incident + "/animals/" + data.animal_object.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>A#{data.animal_object.id_for_incident}</Link></span>
                  <span className="col-4"><b>Species:</b> {data.animal_object.species_string}</span>
                  <span className="col-4"><b>Age:</b> {data.animal_object.age||"Unknown"}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row" style={{textTransform:"capitalize"}}>
                  <span className="col-4"><b>Sex:</b> {data.animal_object.sex||"Unknown"}</span>
                  <span className="col-4"><b>Altered:</b> {data.animal_object.fixed||"Unknown"}</span>
                  <span className="col-4"><b>Weight:</b> {data.animal_object.weight||"Unknown"}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={{textTransform:"capitalize"}}>
                <div className="row">
                  <span className="col-12"><b>Location:</b> {data.animal_object.shelter ? data.animal_object.shelter_object.name : "N/A"} {data.animal_object.room_name ? <span> - {data.animal_object.room_name}</span> : ""}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                  <span><b>Medical Notes:</b> {data.animal_object.medical_notes || "N/A"}</span>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
    </div>
    <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="mb-2 border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginBottom:"-19px"}}>
            <Card.Title>
              <h4 className="mb-0">Treatments</h4>
            </Card.Title>
            <p className="phr mb-3" />
            {Object.keys(trDict).map(tr_date => (
              <span key={tr_date}>
                <h5>Due {tr_date}</h5>
              {trDict[tr_date].sort((a, b) => new Date(a.suggested_admin_time) - new Date(b.suggested_admin_time)).map(treatment_request => (
              <Row key={treatment_request.id} className="ms-0 mb-3">
                <Link href={"/" + organization + "/" + incident + "/vet/treatmentrequest/edit/" + treatment_request.id} className="treatment-link ps-0" style={{textDecoration:"none", color:"white"}}>
                  <Card className="border rounded treatment-hover-div" style={{height:"100px", width:"560px", whiteSpace:"nowrap", overflow:"hidden"}}>
                    <div className="row no-gutters hover-div ms-0" style={{height:"100px", marginRight:"-2px"}}>
                      <Row className="ms-0 me-0 w-100 p-0" style={{flexWrap:"nowrap"}}>
                        <div className="border-end p-0" style={{width:"100px"}}>
                          {treatment_request.treatment_object && ['Eye Medication','Ear Medication'].includes(treatment_request.treatment_object.category) ?
                            <FontAwesomeIcon icon={faEyeDropper} size="6x" className="treatment-icon" style={{marginTop:"5px", marginLeft:"4px"}} transform={'shrink-2'} inverse />
                            : treatment_request.treatment_object && treatment_request.treatment_object.category === 'Patient Care' ?
                            <FontAwesomeIcon icon={faHeart} size="6x" className="treatment-icon" style={{marginTop:"5px", marginLeft:"4px"}} transform={'shrink-2'} inverse />
                            : treatment_request.treatment_object && treatment_request.treatment_object.treatment_object && treatment_request.treatment_object.unit === 'ml' ?
                            <FontAwesomeIcon icon={faSyringe} size="6x" className="treatment-icon" style={{marginTop:"5px", marginLeft:"4px"}} transform={'shrink-2'} inverse />
                          :
                            <FontAwesomeIcon icon={faPrescriptionBottlePill} size="6x" className="treatment-icon" style={{marginTop:"5px", marginLeft:"-1px"}} transform={'shrink-2'} inverse />
                          }
                          </div>
                        <Col className="ms-0 me-0 ps-0 pe-0">
                          <div className="border" style={{paddingTop:"5px", paddingBottom:"7px", paddingLeft:"10px", marginLeft:"-1px", marginTop: "-1px", fontSize:"18px", width:"100%", backgroundColor:"rgb(158 153 153)"}}>
                            Suggested Admin Time: <Moment format="lll">{treatment_request.suggested_admin_time}</Moment>
                            <span className="float-end">
                              {treatment_request.actual_admin_time ?
                              <OverlayTrigger
                                key={"complete-treatment-request"}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-complete-treatment-request`}>
                                    Treatment request is completed.
                                  </Tooltip>
                                }
                              >
                                <FontAwesomeIcon icon={faCheckSquare} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                              </OverlayTrigger>
                              : treatment_request.not_administered ?
                              <OverlayTrigger
                                key={"not-administered-treatment-request"}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-not-administered-treatment-request`}>
                                    Treatment request was not administered.
                                  </Tooltip>
                                }
                              >
                                <FontAwesomeIcon icon={faSquareX} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                              </OverlayTrigger>
                              : new Date(treatment_request.suggested_admin_time) <= new Date() ?
                              <OverlayTrigger
                                key={"awaiting-action-treatment-request"}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-awaiting-action-treatment-request`}>
                                    Treatment request is awaiting action.
                                  </Tooltip>
                                }
                              >
                                <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                key={"scheduled-treatment-request"}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-scheduled-treatment-request`}>
                                    Treatment request is scheduled for a future date/time.
                                  </Tooltip>
                                }
                              >
                                <FontAwesomeIcon icon={faSquareEllipsis} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                              </OverlayTrigger>
                              }
                            </span>
                          </div>
                          {!treatment_request.not_administered ?
                          <span>
                            <Row className="ps-0 pe-0 ms-0 me-0" style={{marginTop:"6px"}}>
                              <Col><b>Actual Admin Time: </b>{treatment_request.actual_admin_time ? <Moment format="lll">{treatment_request.actual_admin_time}</Moment> : "Pending"}</Col>
                            </Row>
                            <Row className="ps-0 pe-0 ms-0 me-0">
                              <Col>
                                <b>Administrator: </b>{treatment_request.assignee_object ? <span>{treatment_request.assignee_object.first_name} {treatment_request.assignee_object.last_name}</span> : "-"}
                              </Col>
                              <Col>
                                <span className="float-end"><b>Num: </b>{treatment_request.num || '-'}</span>
                              </Col>
                            </Row>
                          </span>
                          :
                          <div className="ps-0 pe-0 ms-0 me-0" style={{marginTop:"6px"}}>
                            Not Administered
                          </div>
                          }
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Link>
              </Row>
              ))}
            </span>))}
            {data.treatment_requests.length < 1 ? <p>No treatment requests have been created for this treatment.</p> : ""}
          </Card.Body>
        </Card>
      </div>
    </div>
    {/* <History action_history={data.action_history} /> */}
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Treatment Cancelation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to cancel this treatment and any remaining unadministered treatment requests?</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => cancelTreatmentPlan()}>
          Yes
        </Button>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default TreatmentPlanDetails;
